import React from "react"
import {Box, Typography} from "@mui/material"
import {Carousel, Card, FlexBox} from "@vp/swan"
import {PreviewModes, PurcsPreview} from "@vp/react-product-preview"
import {getAccessToken} from "../../../../../utils/auth"
import SwanConfiguration from "../../../design/SwanConfiguration"
import {ModifiedEvent} from "../types"

const PANEL_HEIGHT = 600

interface PreviewPanelProps {
	event: ModifiedEvent | null
	locale: string
	productKey: string
	optionSelection: Object
	previewInstructionsUri: string
	previewImageClass: string
	placeholder: string
}

const panelWrapperSx = {
	border: "1px solid #ccc",
	borderRadius: 1,
	height: PANEL_HEIGHT,
	overflow: "hidden",
	display: "flex",
	flexDirection: "column" as const,
}

const PreviewPanel: React.FC<PreviewPanelProps> = ({
	event,
	locale,
	productKey,
	optionSelection,
	previewInstructionsUri,
	previewImageClass,
	placeholder,
}) => {
	if (!event) {
		return (
			<Box
				sx={{
					...panelWrapperSx,
					alignItems: "center",
					justifyContent: "center",
					bgcolor: "#fafafa",
				}}
			>
				<Typography variant="body2" color="text.secondary">
					{placeholder}
				</Typography>
			</Box>
		)
	}

	if (event.owner === "Doc Review") {
		return (
			<Box sx={panelWrapperSx}>
				<SwanConfiguration>
					<Box sx={{height: PANEL_HEIGHT}}>
						<Carousel
							aria-label="Carousel Preview of the document"
							accessibleTextForPrevious="Go to previous document"
							accessibleTextForNext="Go to next document"
							aria-roledescription="carouselPreviews"
							skin="full"
							slidesToShow={1}
						>
							{(event.docrefURL as string[]).map((link, index) => (
								<Card bordered key={index}>
									<FlexBox flexDirection="row">
										<img
											src={link}
											alt="Preview"
											className={previewImageClass}
											style={{
												maxHeight: PANEL_HEIGHT,
												width: "100%",
												objectFit: "contain",
											}}
										/>
									</FlexBox>
								</Card>
							))}
						</Carousel>
					</Box>
				</SwanConfiguration>
			</Box>
		)
	}

	return (
		<Box sx={{...panelWrapperSx}}>
			<Box sx={{height: PANEL_HEIGHT}}>
				<PurcsPreview
					purcsOrigin="https://lookup.previews.cimpress.io"
					requestor="care-console"
					previewMode={PreviewModes.Carousel}
					bearerToken={getAccessToken()}
					docRefURL={event.docrefURL as string}
					locale={locale}
					coreProductKey={productKey}
					optionSelections={optionSelection}
					previewInstructionsUri={previewInstructionsUri}
				/>
			</Box>
		</Box>
	)
}

export default PreviewPanel
